<template>
  <div class="com-pages-title">
    <div class="beset">{{title}}</div>
  </div>
</template>

<script>
  /**
   * @Class: components
   * @Module: com-pages-title
   * @Description: 组件 -页标题
   * @Version: 1.0.0
   ---- Created by "Sitdown.liu<731225377@qq.com>" on "2020/4/28 15:51" ---*/
  export default {
    props: ["title"],
    name: "com-pages-title"
  }
</script>

<style lang="less">
  .com-pages-title {
    width: 100%;
    min-width: 1280px;
    padding: 2vh 0;

    .beset {
      width: 100%;
      font-size: 1.6em;
      color: #333333;
      text-align: center;
      letter-spacing: 5px;
      position: relative;

      &::before, &::after {
        content: "";
        display: block;
        width: 35%;
        border-bottom: 1px solid #dddddd;
        position: absolute;
        top: 1.9vh;
      }

      &::before {
        left: 10vw;
      }

      &::after {
        right: 10vw;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/com-pages-title.vue